/**
 * 模态组件状态定义与同步
 * @author chenqunfeng
 * @since 17/10/21
 */

import { SHOW_MODAL, HIDE_MODAL } from 'constants/action.json5';

const initialState = {
  modalType: null,
  modalProps: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps,
      };
    case HIDE_MODAL:
      return {
        modalType: null,
        modalProps: {},
      };
    default:
      return state;
  }
};
